export function clone(target) {
    if (!target) return undefined
    try {
        return JSON.parse(JSON.stringify(target))
    } catch (e) {
        return {}
    }
}
